import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appNumbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private elementValue: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event): any {
    const initalValue = this.elementValue.nativeElement.value;
    this.elementValue.nativeElement.value = initalValue.replace(/\D/g, '');

    if (initalValue !== this.elementValue.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
